import { useEffect, useMemo, useState } from "react";
import {
  COLUMN_BY_KEY,
  DEFAULT_COLUMN_ORDER,
  TRAILING_COLUMNS,
} from "../constants/expandedColumns";

const COLUMN_ORDER_STORAGE_KEY = "operationsJournal.columnOrder";

const readColumnOrder = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(COLUMN_ORDER_STORAGE_KEY));
    if (!Array.isArray(stored)) return DEFAULT_COLUMN_ORDER;
    return [...new Set(stored)].filter((key) => COLUMN_BY_KEY[key]);
  } catch {
    return DEFAULT_COLUMN_ORDER;
  }
};

/** Порядок колонок расширенного вида; общий для всех таблиц журнала */
function useColumnOrder() {
  const [columnOrder, setColumnOrder] = useState(readColumnOrder);

  useEffect(() => {
    localStorage.setItem(COLUMN_ORDER_STORAGE_KEY, JSON.stringify(columnOrder));
  }, [columnOrder]);

  const visibleColumns = useMemo(
    () => [...columnOrder.map((key) => COLUMN_BY_KEY[key]), ...TRAILING_COLUMNS],
    [columnOrder]
  );

  return { columnOrder, setColumnOrder, visibleColumns };
}

export default useColumnOrder;
